import React from 'react';
import {gray, red} from "@ant-design/colors";
import {CheckOutlined, CloseOutlined} from "@ant-design/icons";
import {Descriptions} from "antd";

function SectionProblems({section}) {
    const dataProblems = section.problems.filter(it => it.type === 'DATA');
    const bundleProblems = section.problems.filter(it => it.type === 'BUNDLE');
    const userProblems = section.problems.filter(it => it.type === 'USER' || it.type === 'USER_ALERT');
    const descriptions = [
        {
            key: 1,
            label: 'Status',
            children: <div
                style={{color: section?.adminStatus?.color || gray.primary}}>{section?.adminStatus.text || 'UNKNOWN'}</div>
        },
        {
            key: 2,
            label: 'Data',
            children: dataProblems?.length ? dataProblems.map(prob => {
                return <div key={prob.message} style={{color: red.primary}}>{prob.message}</div>
            }) : <div><CheckOutlined/> OK </div>
        },
        {
            key: 3,
            label: 'Bundle',
            children: <div className="d-col gap-3"> {bundleProblems?.length ? bundleProblems.map((prob,i) => {
                return <div key={prob.message + i} className="d-row gap-3">
                    <CloseOutlined style={{color: red.primary}}/>
                    <div>{prob.message}</div>
                </div>
            }) : <div className="d-row gap-3"><CheckOutlined/> OK </div>}</div>
        },
        {
            key: 4,
            label: 'User Message',
            children: userProblems?.length ? userProblems.map((prob,i) => {
                return <div key={prob.message + i} style={{color: red.primary}}>{prob.title}</div>
            }) : <div><CheckOutlined/> OK </div>
        },
    ]
    if (!section.progress){
        return null
    }
    return (
        <Descriptions style={{minWidth: 250}} column={2} size="small" items={descriptions}/>
    );
}

export default SectionProblems;